import Button from '../../button/Button';
import Modal from '../../modal/Modal';
import add_circle from '../../../assets/add_circle.svg';

interface Props {
  isModalOpen: boolean;
  setIsModalOpen: (value: boolean) => void;
  allowButtonClosed: boolean;
  handleClick: () => void;
  isLoading?: boolean;
}

const ToastNoCredit: React.FC<Props> = ({
  isModalOpen,
  isLoading,
  setIsModalOpen,
  allowButtonClosed,
  handleClick,
}) => {
  return (
    <>
      <Modal
        allowButtonClosed={allowButtonClosed}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title='Sem créditos para recarga'
        styleEnterButton={{
          backgroundColor: 'var(--Primary-Regular, #3CCC10)',
          border: 'none',
        }}
        textEnterButton='Adicionar créditos'
        handleEnterButton={handleClick}
        isLoadingEnterButton={isLoading}
        imageEnterButton={<img alt='add-button-icon' src={add_circle} />}
      >
        <p>Adicione créditos para recarregar seu carro.</p>
      </Modal>
    </>
  );
};

export default ToastNoCredit;
